export const formatZAR = (n: number) =>
  new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    minimumFractionDigits: 2,
  }).format(n);

/**
 * Format a percentage value (e.g. 0.345, 1.7, 5) with dynamic precision.
 * Guarantees minimum 2 decimal places (e.g. "1,70%", "5,00%"), expanding up to
 * maxDecimals (default 4) when fractional precision is present (e.g. "0,345%").
 */
export const formatPercent = (pct: number, minDecimals = 2, maxDecimals = 4) => {
  const num = Number(pct) || 0;
  return `${new Intl.NumberFormat('en-ZA', {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  }).format(num)}%`;
};

export const formatCredits = (n: number) =>
  `${new Intl.NumberFormat('en-ZA', { maximumFractionDigits: 0 }).format(n)} credits`;

export const formatCompactNumber = (n: number) =>
  new Intl.NumberFormat('en-ZA', { notation: 'compact', maximumFractionDigits: 1 }).format(n);

export const relativeTime = (iso: string) => {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

export const formatUptime = (seconds: number) => {
  const hrs = Math.floor(seconds / 3600);
  if (hrs >= 24) return `${Math.floor(hrs / 24)}d ${hrs % 24}h`;
  if (hrs >= 1) return `${hrs}h ${Math.floor((seconds % 3600) / 60)}m`;
  return `${Math.floor(seconds / 60)}m`;
};
